import React, { Component } from 'react'
import './content.css'

export default class Content4 extends Component {
    render() {
        return (
            <div className="card">
            <div className="img-container">
            <img src="https://media.istockphoto.com/photos/beautiful-mixed-race-mother-and-daughter-relaxing-outdoors-together-picture-id1322800279?b=1&k=20&m=1322800279&s=170667a&w=0&h=RrdfWWBLio2TdBayKgZruCoR-naiWfGuBzTvSXqfym4=" alt=""/>

            </div>
            <h2>Aid Platform</h2>
            <p>This is a design for an application that can help users to get help online.
                Once a user logs in we expect to track their location, and they can make a request on 
                what kind of help they require. either they can volunteer to other people's request or themselves seek help.
                <br/>
          <a href="https://www.figma.com/proto/OmIZ5SbYi8fgZFV1UQOyNC/aid-platform?node-id=369%3A284&starting-point-node-id=41%3A0">Check on Figma</a></p>
            
            </div>
          
        )
    }
}
